program Leasing;

{$R *.dres}

uses
  WEBLib.Forms,
  Factor in 'Factor.pas'{*.html},
  uSubForm1 in 'uSubForm1.pas'{*.html},
  Unit2 in 'Unit2.pas'{*.html},
  Unit3 in 'Unit3.pas'{*.html},
  Unit4 in 'Unit4.pas'{*.html};

{$R *.res}

begin
  Application.Initialize;
  Application.MainFormOnTaskbar := True;
  Application.CreateForm(TForm1, Form1);
  Application.CreateForm(TSubForm1, SubForm1);
  Application.CreateForm(TForm2, Form2);
  Application.CreateForm(TForm3, Form3);
  Application.CreateForm(TForm4, Form4);
  Application.Run;
end.
